export default __webpack_public_path__ + "static/media/mail.1302f4d7.svg";